/**
 * @module Section-Home2-Slider
 */

import { NavLink, useNavigate } from "react-router-dom";
import { navUrl, publicUrlFor } from "../../../../globals/common-functions";
import { route } from "../../../../globals/constants";
import { TypeSectionSlider } from "../../../@types/sectionTypes";

/**
 * 
 * @param props : Data supplied to display slider
 * @returns Markup for section containing different slider
 */
const SectionHome2Slider = (
    props: {
        _slider: TypeSectionSlider
    }
) => {
    const { _slider } = props;
    const navigate = useNavigate();

    const handleDiscoverMore = (e: React.MouseEvent) => {
        e.preventDefault();
        const currentPath = window.location.pathname;
        
        if (currentPath !== '/') {
            navigate('/#services');
        } else {
            const $services = (window as any).$ ? (window as any).$('#services') : null;
            if ($services && $services.length) {
                (window as any).$('html, body').stop().animate({
                    scrollTop: $services.offset().top
                }, {
                    duration: 1000,
                    complete: function() {
                        if (window.location.hash === '#services') {
                            window.history.replaceState(null, '', window.location.pathname + window.location.search);
                        }
                        (window as any).$('html, body').css({ overflow: '', height: '' });
                    }
                });
            }
        }
    };

    return (
        <div className="section-full av-bnr-2-wrap-outer home-2-slider swi-dotts swiper-container-fw">
            {/* swiper slides */}
            <div className="swiper-wrapper">
                {
                    _slider.slides.map((_item, _index) => {
                        return (
                            <div key={_index} className="av-bnr-2-wrap swiper-slide overlay-overlay" style={{ backgroundImage: `url(${publicUrlFor(_item.image)})` }}>
                                <div className="sx-bg-overlay opacity-0 sx-bg-primary" />
                                <div className="container">
                                    <div className="av-bnr-2-content">
                                        <h2 className="av-bnr-2-large-title">{_item.title}</h2>
                                        <div className="av-bnr-2-info">{_item.subtitle}</div>
                                        <div className="av-bnr-readmore">
                                            <button onClick={handleDiscoverMore} className="site-button">
                                                Discover More
                                                <i className="fa fa-plus" />
                                            </button>
                                            <NavLink to={navUrl.pages(route.pages.CONTACT)} className="site-button outline-white">
                                                Contact Us
                                                <i className="fa fa-plus" />
                                            </NavLink>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
            {/* !swiper slides */}
            <div className="swiper-pagination" />
            <div className="swiper-button-wrap">
                {/* Add Arrows */}
                <div className="swiper-button-next" />
                <div className="swiper-button-prev" />
            </div>
        </div>
    )
}
export default SectionHome2Slider;